import React from 'react'
import styled from 'styled-components'
import { Card, Divider, Flex, LinkButton, Text, ProgressBar } from 'adl'
import numeral from 'numeral'
import {
  VictoryAxis,
  VictoryBar,
  VictoryChart,
  VictoryStack,
  VictoryTheme
} from 'victory'

//import MarketingTile from './MarketingTile'
import AdCarousel from './AdCarousel'

const MutedText = styled.div`
  color: ${props => props.theme.colors.gray500};
  font-size: 0.8rem;
`
const Goal = ({ label, total, current, ...rest }) => {
  return (
    <div {...rest}>
      <Flex
        justify="space-between"
        style={{ marginBottom: '0.25rem', fontSize: '0.8rem' }}
      >
        <div>{label}</div>
        <div>{numeral(total).format('$0,0.00')}</div>
      </Flex>
      <ProgressBar
        min={0}
        max={total}
        value={current}
        style={{ marginBottom: '0.25rem' }}
      />
      <Flex justify="space-between">
        <MutedText>{numeral(current).format('$0,0.00')}</MutedText>
        <MutedText>{numeral(total - current).format('$0,0.00')} left</MutedText>
      </Flex>
    </div>
  )
}

const categorizedSpends = {
  entertainment: [
    { month: 1, spending: 1300 },
    { month: 2, spending: 1650 },
    { month: 3, spending: 1425 },
    { month: 4, spending: 1900 }
  ],

  food: [
    { month: 1, spending: 1500 },
    { month: 2, spending: 1250 },
    { month: 3, spending: 1950 },
    { month: 4, spending: 1300 }
  ],

  health: [
    { month: 1, spending: 1150 },
    { month: 2, spending: 1325 },
    { month: 3, spending: 2000 },
    { month: 4, spending: 1550 }
  ],

  house: [
    { month: 1, spending: 1800 },
    { month: 2, spending: 1325 },
    { month: 3, spending: 1500 },
    { month: 4, spending: 1200 }
  ]
}
const Chart = () => (
  <VictoryChart
    width={256}
    height={256}
    padding={{ top: 10, left: 40, right: 0, bottom: 30 }}
    domainPadding={40}
    theme={VictoryTheme.material}
  >
    <VictoryAxis
      tickValues={[1, 2, 3, 4]}
      tickFormat={['Sep', 'Oct', 'Nov', 'Dec']}
    />
    <VictoryAxis dependentAxis tickFormat={x => `$${x / 1000}k`} />
    <VictoryStack colorScale={'qualitative'}>
      {Object.keys(categorizedSpends).map((cat, index) => (
        <VictoryBar
          key={`category-${index}`}
          data={categorizedSpends[cat]}
          x="month"
          y="spending"
        />
      ))}
    </VictoryStack>
  </VictoryChart>
)

const RatingText = styled.div`
  text-align: center;
  color: ${props => props.theme.colors.gray500};
`

const Swatches = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`

const Swatch = styled.div`
  height: 6px;
  width: 100%;
  background-color: ${props => props.color || 'black'};

  margin-left: 2px;
  margin-right: 2px;

  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
`

const CreditScore = () => (
  <Card elevation={2}>
    <Card.Body>
      <Text style={{ marginBottom: '2rem' }}>
        <strong>Your Credit Score</strong>
      </Text>
      <RatingText color={'gray400'}>
        RATING: <span style={{ color: '#91bf0e' }}>GOOD</span>
      </RatingText>
      <Text
        style={{ textAlign: 'center', fontSize: '3rem', marginBottom: '1rem' }}
      >
        723
      </Text>
      <Swatches>
        <Swatch color={'#d92623'} />
        <Swatch color={'#f09101'} />
        <Swatch color={'#f6dc1f'} />
        <Swatch color={'#91bf0e'} />
        <Swatch color={'#3c9853'} />
      </Swatches>

      <div style={{ textAlign: 'center' }}>
        <Text muted style={{ fontSize: '0.75rem', marginBottom: 2 }}>
          As of April 1, 2020
        </Text>
      </div>
      <LinkButton
        color="gray600"
        style={{ marginLeft: 'auto', marginRight: 'auto' }}
      >
        <i className="icon-swap" />
        {'  '}Refresh Score
      </LinkButton>
    </Card.Body>
    <Divider />
    <div style={{ padding: 4 }}>
      <LinkButton style={{ marginLeft: 'auto', marginRight: 'auto' }}>
        Details
      </LinkButton>
    </div>
  </Card>
)

export default () => (
  <div style={{ maxWidth: 768 }}>
    <CreditScore />

    {/*
      <MarketingTile style={{ marginBottom: '2rem' }} />
      */}
    <AdCarousel />

    <Card elevation={2}>
      <Card.Body>
        <Text style={{ marginBottom: 4 }}>
          <strong>Monthly Spending</strong>
        </Text>
        <Text style={{ fontSize: '0.8rem', color: '#667' }}>
          10 days left in December
        </Text>
        <Chart />
      </Card.Body>

      <Divider />
      <div style={{ padding: 4 }}>
        <LinkButton style={{ marginLeft: 'auto', marginRight: 'auto' }}>
          Details
        </LinkButton>
      </div>
    </Card>
    <Card elevation={2}>
      <Card.Body>
        <Text>
          <strong>Savings Goals</strong>
        </Text>

        <Flex justify="space-between" style={{ marginBottom: '0.5rem' }}>
          <div>Total Goal</div>
          <div>$5,000.00</div>
        </Flex>
        <ProgressBar value={2100} max={5000} />
      </Card.Body>
      <Divider />
      <Card.Body>
        <Goal
          label={'Europe Vacation'}
          total={3000}
          current={500}
          style={{ marginBottom: '1rem' }}
        />
        <Goal label={'Savings'} total={2000} current={1600} />
      </Card.Body>
      <Divider />

      <div style={{ padding: 4 }}>
        <LinkButton style={{ marginLeft: 'auto', marginRight: 'auto' }}>
          Details
        </LinkButton>
      </div>
    </Card>
  </div>
)
